import ReactGA from "react-ga4";

interface ArcAnalyticsOptions {
  [key: string]: any;
}

interface PreviewParams {
  page: string;
  title: string;
}

export default class ArcAnalytics {
  private id: string;
  private options: ArcAnalyticsOptions;

  constructor({ id, options = {} }: { id: string; options?: ArcAnalyticsOptions }) {
    this.id = id;
    this.options = options;
  }

  init(): void {
    ReactGA.initialize([
      { trackingId: this.id, gaOptions: this.options, gtagOptions: {} },
    ]);
  }

  preview({ page, title }: PreviewParams): void {
    ReactGA.send({ hitType: "pageview", page, title });
  }
}
